import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
var styles = require('./HeaderContainer.scss');
var HeaderContainer = /** @class */ (function (_super) {
    tslib_1.__extends(HeaderContainer, _super);
    function HeaderContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderContainer.prototype.render = function () {
        return (React.createElement("div", { className: this.props.className },
            React.createElement("div", { className: styles.header }, this.props.header),
            this.props.children));
    };
    HeaderContainer = tslib_1.__decorate([
        observer
    ], HeaderContainer);
    return HeaderContainer;
}(React.Component));
export default HeaderContainer;
//# sourceMappingURL=HeaderContainer.js.map